import { defineStore } from 'pinia'
import { toRefs } from 'vue'
import { createState, resetState } from './state'
import { createActions } from './actions'
import { createGetters } from './getters'

export const useTicketsStore = defineStore('tickets', () => {
  const state = createState()
  const actions = createActions(state)
  const getters = createGetters(state)

  // Reset function for security - clears all data on logout/tenant switch
  const $reset = () => {
    resetState(state)
  }

  return {
    // State (using toRefs to maintain reactivity)
    ...toRefs(state),
    // Actions
    ...actions,
    // Getters
    ...getters,
    // Reset
    $reset,
  }
})

export type { CreateTicketData, UpdateTicketData } from './actions'
